import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import Const from '@/helper/const'
import ClientType from '@/helper/ClientType'
import {
  FileDownloadButton,
  DetailedTradeReport
} from '@/components'

export default {
  components: {
    FileDownloadButton,
    DetailedTradeReport
  },
  data () {
    return {
      rules: {
        datadc: (value) => this.validateDate(value) || 'Insira um valor válido e tente novamente'
      },
      selectedClient: '',
      selectedTypeClient: null,
      clientType: ClientType,
      typeClients: [
        {
          name: 'Pré Pago',
          id: 'pre'
        },
        {
          name: 'Pós Controle',
          id: 'pos_controle'
        },
        {
          name: 'Pós Pago',
          id: 'pos_pago'
        }
      ],
      loading: false,
      items: [],
      basketClientsReport: [],
      total: 0,
      pagination: {},
      selected: [],
      selectedItems: [],
      idcallmanagerSelected: [],
      allChecked: false,
      headers: [
        { text: 'Ações', align: 'center', sortable: false },
        { text: 'Cliente', value: 'clientName', align: 'left' },
        { text: 'CNPJ', value: 'cnpj', align: 'right' },
        { text: 'Total consultas', value: 'countCallManagers', align: 'right' },
        { text: 'Saldo devedor (R$)', value: 'creditosConsumidos', align: 'right' },
        { text: 'Limite (R$)', value: 'limitClient', align: 'right' },
        { text: 'Crédito (R$)', value: 'limitClient', align: 'right' }
      ],
      startDate: moment().format('DD/MM/YYYY'),
      endDate: moment().format('DD/MM/YYYY'),
      dossieUrl: '',
      menuEndDate: false,
      menuStartDate: false,
      cnpj: null,
      selectedTypeDefault: '',
      dialogInformationAccount: false,
      selectedItem: null,
      isLoadingDatatable: false,
      isLoading: false,
      clientDatails: null
    }
  },
  computed: {
    ...mapGetters([
      'getterClients',
      'getterClientsExtractCommershal'
    ]),
    options () {
      return {
        loading: this.isLoadingDatatable
      }
    }
  },
  watch: {
    pagination: {
      handler () {
        if (this.items && this.items.length > 0) {
          this.generateReport()
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'actionExtractClients',
      'actionListExtractByClient'
    ]),
    capitalize (val) {
      return val ? val[0].toUpperCase() + val.slice(1) : ''
    },
    validateDate (date) {
      if (!date) {
        return true
      }
      const isDateValid = moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY')
      if (isDateValid !== 'Invalid date') {
        return true
      }
      return false
    },
    generateReport () {
      const {
        sortBy, descending, page, rowsPerPage
      } = this.pagination

      const params = {
        sortBy: this.capitalize(sortBy),
        descending,
        page,
        size: rowsPerPage,
        startDate: `${moment(this.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')}T00:00:00`,
        endDate: `${moment(this.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')}T23:59:59`,
        type: this.selectedTypeClient
      }

      this.isLoadingDatatable = true

      this.actionExtractClients(params)
        .then(() => {
          this.total = this.getterClientsExtractCommershal.totalRows
          this.items = this.getterClientsExtractCommershal.commercialReportDto

          this.isLoadingDatatable = false
        })
        .catch(() => {
          this.isLoadingDatatable = false

          this.sendToast({
            text: 'Ocorreu um erro ao buscar os dados, tente novamente mais tarde.',
            type: 'danger'
          })
        })
    },
    linkToDownload (item) {
      return `${Const.SERVICE_DOSSIE}/extrato/periodo/${item.clientId}?startDate=${moment(this.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')}T00:00:00&endDate=${moment(this.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')}T23:59:59`
    },
    linkToDownloadExcel (id) {
      return `${Const.SERVICE_DOWNLOAD_SPREADSHEET_ALL}/commercial-report/${id}?startDate=${moment(this.startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')}T00:00:00&endDate=${moment(this.endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')}T23:59:59`
    }
  }
}
